import { MouseEvent, useCallback, useState, useEffect } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { MAX_DESCRIPTION_LENGTH } from 'APP/constants/group';

interface ISeeMoreDescriptionPresenter {
  description: string;
  showMore: (event: MouseEvent) => void;
  isMoreButton: boolean;
}

export function useSeeMoreDescriptionPresenter(description: string): ISeeMoreDescriptionPresenter {
  const { t } = useTranslation();
  const [hasShowMore, setHasShowMore] = useState(false);
  const [isClickShowMore, setClickShowMore] = useState(false);

  const maxDescriptionLength = MAX_DESCRIPTION_LENGTH - t('group_description_more').length;
  const isMoreButton = hasShowMore && !isClickShowMore;

  const showMore = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      setClickShowMore(true);
    },
    [setHasShowMore]
  );

  useEffect(() => {
    setHasShowMore(description.length > maxDescriptionLength);
  }, [description]);

  return {
    description: isMoreButton ? description.slice(0, maxDescriptionLength) + ' ' : description,
    showMore,
    isMoreButton,
  };
}
